import { graphql } from "gql.tada";

export const QuotationCarouselSectionFragment = graphql(
  `
    fragment QuotationCarouselSectionFragment on QuotationCarouselSection {
      sys {
        id
      }
      internalLabel
      quotationsCollection(limit: 10) {
        items {
          sys {
            id
          }
          quotation
          attributionName
          attributionPosition
          attributionCompany
        }
      }
    }
  `
);
